export const config = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://tarot-backend-git-main-amanrawat882s-projects.vercel.app',
  
  // Development Settings
  USE_MOCK_DATA: process.env.REACT_APP_USE_MOCK_DATA === 'true',
  REFRESH_INTERVAL: parseInt(process.env.REACT_APP_REFRESH_INTERVAL || '30000'),
  
  // Debug Settings
  DEBUG_MODE: process.env.REACT_APP_DEBUG_MODE === 'true',
  LOG_API_CALLS: process.env.REACT_APP_LOG_API_CALLS === 'true',
  
  // Feature Flags
  ENABLE_HEALTH_CHECK: true,
  ENABLE_AUTO_REFRESH: true,
  ENABLE_ERROR_BOUNDARY: true,
};

export default config;
